import mine from './notify.vue';

export default box => {

    return function (...args) {

        let first = args[0],
            second = args[1],
            cons_first = first?.constructor,
            cons = second?.constructor;
        
        if (cons_first != Number && cons_first != String)
            console.error("The first argument of the alert or confirm method must be an Number or String")

        if(!cons == Object && !second && second !== undefined)
            console.error("The second argument of the alert or confirm method must be an object")

        return box(mine,{
            position: {
                bottom: 0,
                right: 0
            },
            ...second,
            unframe: true,
            mask: false,
            hideHeader: true,
            minWidth: 100,
            minHeight: 100,
            continuous: true,
            props: {
                content: first.toString()
            },
            ons: mine.name == 'confirm' ? ['onSure','onDeny'] : []
        })
    }
}